import {Shape as ShapeData} from '../../lib/shapes'
import { useMediaQuery } from 'react-responsive'
import { REVEAL_FAST_TIME_MS } from '../../constants/settings'

export class Color {
  constructor(readonly hex: string, readonly label: string){}
}

type Props = {
  shape: ShapeData,
  isDarkMode: boolean,
  useMargin: boolean,
  position?: number
  size?: number
  containerSize?: number
  isCelebrating?: boolean
  revealTime?: number
}

export const Shape = ({shape, isDarkMode, useMargin, size, containerSize, position=0, isCelebrating=false, revealTime=REVEAL_FAST_TIME_MS}: Props) => {
  const isSm = useMediaQuery({ query: '(min-width: 640px)' })
  size = size ?? (isSm ? 9: 6);
  let sizeRem = size * 0.25
  if(!shape.lighten) {
    // april fools hack
    sizeRem += isSm ? 1.5 : .85 ;
  }
  containerSize = containerSize ?? size + 5 
  const shapeSize = `${sizeRem}rem`;
  const bounce = isCelebrating ? 'bounce' : '';
  const fill = isDarkMode && shape.lighten ? shape.color!.darkHex : shape.color!.hex;
  const animationDelay = `${position * revealTime}ms`
  return (
    <>
    <div 
      aria-label={`${shape.color!.label} ${shape.label}`}
      tabIndex={0}
      role="listitem"
      style={{ animationDelay }} 
      className={`${bounce} w-${containerSize} h-${containerSize} flex items-center justify-center ${useMargin? 'mx-0.5': ''} text-5xl text-center font-bold font-mono rounded`}>
      {shape.render({height: shapeSize, width: shapeSize, fill: fill})}
    </div>
    </>
  )
}
